import { branchConstants } from '../../_constants';

export function branches(state = {}, action) {
    switch (action.type) {
        case branchConstants.BRANCH_FETCHING:
            return {
                ...state,
                branchFetching: true
            };
        case branchConstants.BRANCH_FETCHED:
            return {
                ...state,
                branchFetching: false
            };
        case branchConstants.BRANCH_SUBMITTING:
            return {
                ...state,
                branchSubmitting: true
            };
        case branchConstants.BRANCH_SUBMITTED:
            return {
                ...state,
                branchSubmitting: false
            };
        case branchConstants.GET_BRANCHES:
            return {
                ...state,
                branches: action.branches,
            };
        case branchConstants.GET_BRANCH_BY_ID:
            return {
                ...state,
                branch: action.branch
            };
        case branchConstants.GET_ACTIVE_BRANCHES:
            return {
                ...state,
                activeBranches: action.activeBranches,
            };
        case branchConstants.GET_BRANCH_FROM_BASE:
            return {
                ...state,
                branchFromBASE: action.branchFromBASE,
            };
        default:
            return state;
    }
}